import { keepPreviousData, useQuery } from "@tanstack/vue-query";
import { customerSupportApi } from "../adapters/customerSupport";
import { TicketDashboardRequestParams } from "@telegraphio/bapi-types";
import { ComputedRef, MaybeRefOrGetter, toValue } from "vue";
import { customRetry } from "@/plugins/vueQuery";

// --
// Tickets
// --
export function useGetTickets(
  customerId: string,
  requestData: MaybeRefOrGetter<Partial<TicketDashboardRequestParams>>,
) {
  return useQuery({
    placeholderData: keepPreviousData,
    queryKey: ["tickets", customerId, requestData] as const,
    queryFn: () => customerSupportApi.getTickets(customerId, toValue(requestData)),
    retry: customRetry,
  });
}

export function useGetTicket(customerId: string, ticketId: string, enabled: ComputedRef<boolean>) {
  return useQuery({
    enabled: () => toValue(enabled),
    queryKey: ["ticket", customerId, ticketId],
    queryFn: () => customerSupportApi.getTicket(customerId, ticketId),
    retry: customRetry,
  });
}
// --
// Ticket Notes
// --
export function useGetTicketNotes(customerId: string, ticketId: string) {
  return useQuery({
    queryKey: ["ticketNotes", customerId, ticketId],
    queryFn: () => customerSupportApi.getTicketNotes(customerId, ticketId),
    retry: customRetry,
  });
}

export function useGetTicketNoteSignedUploadURL(customerId: string) {
  return useQuery({
    queryKey: ["ticketNoteSignedUploadURL", customerId],
    queryFn: () => customerSupportApi.getTicketNoteSignedUploadURL(customerId),
    retry: customRetry,
  });
}
